import React, { useEffect, useState } from "react";
import api from "../../../services/api";

export function AdminDashboard(){


  const [usuarios, setUsuarios] = useState([]);


  useEffect(()=>{

    carregarUsuarios();

  },[]);



  async function carregarUsuarios(){

    try {

      const resposta = await api.get(
        "/admin/usuarios.php"
      );


      setUsuarios(resposta.data);


    } catch(error){

      console.error(error);

    }

  }




  async function alterarStatus(id,status){


    try {


      await api.post(
        "/admin/status.php",
        {
          id,
          status
        }
      );


      carregarUsuarios();


    }catch(error){

      console.error(error);

    }

  }





return (

<div className="
font-body
space-y-8
animate-in
fade-in
duration-300
">


{/* Cabeçalho */}

<div
className="
bg-white
border
border-border
rounded-card
p-6
shadow-sm
"
>


<h1
className="
font-display
text-h2
font-bold
text-text-primary
"
>

Painel Administrativo

</h1>


<p className="text-text-secondary mt-2">

Gerencie usuários, planos e status das contas.

</p>


</div>





{/* Indicadores */}


<div
className="
grid
grid-cols-1
md:grid-cols-4
gap-4
"
>


<div className="
bg-white
border
border-border
rounded-card
p-5
">

<p className="text-caption text-text-secondary">

Usuários

</p>


<h2 className="text-h3 font-bold">

{usuarios.length}

</h2>


</div>





<div className="
bg-white
border
border-border
rounded-card
p-5
">


<p className="text-caption text-text-secondary">

Contas Ativas

</p>


<h2 className="text-h3 font-bold text-green-600">

{
usuarios.filter(
u=>u.status_conta==="ATIVA"
).length
}

</h2>


</div>






<div className="
bg-white
border
border-border
rounded-card
p-5
">


<p className="text-caption text-text-secondary">

Contas Bloqueadas

</p>


<h2 className="text-h3 font-bold text-red-600">

{
usuarios.filter(
u=>u.status_conta==="INATIVA"
).length
}

</h2>


</div>






<div className="
bg-white
border
border-border
rounded-card
p-5
">


<p className="text-caption text-text-secondary">

Planos Ativos

</p>


<h2 className="text-h3 font-bold">

{
usuarios.filter(
u=>u.plano
).length
}

</h2>


</div>


</div>







{/* Tabela usuários */}


<div
className="
bg-white
border
border-border
rounded-card
shadow-sm
p-6
"
>


<h2
className="
text-xl
font-bold
mb-6
"
>

Usuários cadastrados

</h2>



<div className="overflow-x-auto">


<table className="w-full">


<thead>


<tr
className="
border-b
text-left
text-sm
"
>


<th className="p-3">
Nome
</th>


<th className="p-3">
Email
</th>


<th className="p-3">
Plano
</th>


<th className="p-3">
Status
</th>


<th className="p-3">
Ações
</th>


</tr>


</thead>




<tbody>


{

usuarios.map((usuario)=>(


<tr
key={usuario.id}
className="border-b"
>


<td className="p-3">

{usuario.nome}

</td>


<td className="p-3">

{usuario.email}

</td>


<td className="p-3">

{usuario.plano || "Sem plano"}

</td>



<td className="p-3">


<span
className={`
px-3
py-1
rounded-full
text-xs
font-semibold

${
usuario.status_conta==="ATIVA"

?
"bg-green-100 text-green-700"

:

"bg-red-100 text-red-700"

}

`}
>


{usuario.status_conta}


</span>


</td>





<td className="p-3">


{

usuario.status_conta==="ATIVA"

?


<button

onClick={()=>
alterarStatus(
usuario.id,
"INATIVA"
)
}

className="
bg-red-500
text-white
px-3
py-2
rounded-lg
text-sm
"

>

Bloquear

</button>



:


<button

onClick={()=>
alterarStatus(
usuario.id,
"ATIVA"
)
}

className="
bg-green-600
text-white
px-3
py-2
rounded-lg
text-sm
"

>

Ativar

</button>


}



</td>



</tr>


))


}


</tbody>


</table>


</div>


</div>


</div>


);


}